import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlSignature } from '../common/apiEndPoint';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface SignupRequest {
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber: string;
  typeofStudent: string;
  password: string;
  howDidYouHearAboutUs: string;
}

export interface SignupResponse {
  message: string;
  status: number;
  userId?: string;
  success: boolean;
  data?: any;
}

export interface ApiError {
  status: number;
  error: {
    message: string;
    details?: any;
  };
}

@Injectable({
  providedIn: 'root',
})
export class GetstartedService {
  private signupUrl: string;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private urlSignature: UrlSignature) {
    this.signupUrl = urlSignature.paymentsignupUrl;
  }

  submitSignup(signupData: SignupRequest): Observable<SignupResponse> {
    return this.http
      .post<SignupResponse>(this.signupUrl, signupData, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError = (error: any): Observable<never> => {
    console.error('Signup service error:', error);

    const transformedError: ApiError = {
      status: error.status || 500,
      error: {
        message: error.error?.message || error.message || 'An unexpected error occurred',
        details: error.error || error,
      },
    };

    return throwError(() => transformedError);
  };
}